<template>
  <li class="navbar-item">
    <a v-if="external" :href="path">
      {{text}}
    </a>
    <router-link v-else exact :to="path" >{{text}}</router-link>
  </li>
</template>

<script>
export default {
  name: 'navbar-item',
  props: {
    path: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    external: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="less" scoped>
@import (reference) "../../../assets/css/variable.less";
.navbar-item {
  display: block;
  float: right;
  a {
    line-height: 60px;
    height: 60px;
    display: block;
    padding: 0px 25px;
    color: #000;
    font-size: 14px;
    font-weight: bold;
    position: relative;
    transition: all 0.4s linear;
    -webkit-transition: all 0.4s linear;
    -moz-transition: all 0.4s linear;
    -ms-transition: all 0.4s linear;
    -o-transition: all 0.4s linear;

    &::before {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &:hover {
      color: #444;
    }

    &::before {
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      transform-origin: center;
    }

    &::before {
      border-bottom: 2px solid @green;
      transform: scale3d(0, 1, 1);
    }

    &:hover::before {
      transform: scale3d(1, 1, 1);
      transition: transform 0.5s;
    }
  }
  .router-link-active {
    &:before {
      transform: scale3d(1, 1, 1);
      transition: transform 0.5s;
    }
    color: #444444;
  }
}
@media screen and (max-width: 992px) {
  .navbar-item {
    display: block;
    margin-left: 0;
    float: none;
    margin-bottom: 5px;
    a {
      color: #000;
      display: block;
      line-height: 60px;
      height: 60px;
      width: 200px;
      padding: 0 25px;
      &:after {
        display: none;
      }
      &:before {
        border-top: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .navbar-item a {
    padding: 0 10px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/navbar/navbar-item.vue